import axios from 'axios';

import { BASE_URL } from './config';
const ENDPOINT = '/api/employees/upload';

export function postActiveEmployees(file: File) {
  const TOKEN = sessionStorage.getItem('Token');

  const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN,
    },
  });

  const formData = new FormData();
  formData.append('employees', file);

  return apiClient.post(ENDPOINT, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
